module.exports = __webpack_public_path__ + "static/img/X6作业控制器.d7fbe87.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/products/type2-1-model/X6作业控制器.png
// module id = n3TM
// module chunks = 0